<script>
  export let noMarginTop = true;
</script>

<div class="header" class:noMarginTop><slot></slot></div>

<style>
  .header {
    font-size: 25px;
    /* margin-bottom: var(--main-gutter-vertical); */
    margin-bottom: 20px;
  }

  @media screen and (max-width: 720px) {
    .header {
      margin-top: 20px;
      margin-bottom: 20px;
    }
    .noMarginTop {
      margin-top: 0;
    }
  }
</style>
